module.exports = __webpack_public_path__ + "assets/images/USDUNFIT20.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USDUNFIT20.png
// module id = 1469
// module chunks = 1